var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component follow-record-base"},[_c('follow-record-note'),_c('follow-record-case-status'),_c('follow-record-insert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }